import { combineReducers } from "redux";
import Layout from "./layout/reducer";
import Login from "./auth/login/reducer";
import Profile from "./auth/profile/reducer";
import Dashboard from "./dashboard/reducer";
import Communications from "./communications/reducer";


const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Profile,
  Dashboard,
  Communications
});

export default rootReducer;
